import { getJson, postJson } from '@/lib/apiClient';
import type {
  DetectInput,
  MetricPoint,
  QualityAnomaly,
  QualityMetric,
  QualityScorecard,
} from '@/features/quality/types';

interface Wrapped<T> {
  data: T;
}

export interface AnomalyFilters {
  asset_fqn?: string;
  status?: string;
}

export const qualityApi = {
  anomalies: (filters: AnomalyFilters): Promise<QualityAnomaly[]> =>
    getJson<Wrapped<QualityAnomaly[]>>('/quality/anomalies', {
      asset_fqn: filters.asset_fqn,
      status: filters.status,
    }).then((r) => r.data),

  metrics: (assetFqn: string, metric: QualityMetric, days = 90): Promise<MetricPoint[]> =>
    getJson<Wrapped<MetricPoint[]>>('/quality/metrics', {
      asset_fqn: assetFqn,
      metric,
      days,
    }).then((r) => r.data),

  profileDataset: (datasetId: string): Promise<{ recorded: number }> =>
    postJson<{ recorded: number }>(`/quality/datasets/${datasetId}/profile`),

  detect: (input: DetectInput): Promise<QualityAnomaly[]> =>
    postJson<Wrapped<QualityAnomaly[]>>('/quality/detect', input).then((r) => r.data),

  acknowledge: (id: string): Promise<QualityAnomaly> =>
    postJson<Wrapped<QualityAnomaly>>(`/quality/anomalies/${id}/acknowledge`).then((r) => r.data),

  resolve: (id: string): Promise<QualityAnomaly> =>
    postJson<Wrapped<QualityAnomaly>>(`/quality/anomalies/${id}/resolve`).then((r) => r.data),

  scorecard: (): Promise<QualityScorecard> => getJson<QualityScorecard>('/quality/scorecard'),
};

export const qualityKeys = {
  anomalies: (filters: AnomalyFilters) => ['quality', 'anomalies', filters] as const,
  metrics: (assetFqn: string, metric: string) => ['quality', 'metrics', assetFqn, metric] as const,
  scorecard: ['quality', 'scorecard'] as const,
};
